// Best-effort custom event tracking. Routes to whichever analytics snippet
// is loaded on the page (Cloudflare RUM, Plausible, GA4). Always safe to
// call -- no-ops in dev or before any beacon loads.

type Props = Record<string, string | number | boolean | undefined>;

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;

function readUtm(): Props {
  if (typeof window === 'undefined') return {};
  try {
    const params = new URLSearchParams(window.location.search);
    const out: Props = {};
    for (const k of UTM_KEYS) {
      const v = params.get(k);
      if (v) out[k] = v;
    }
    return out;
  } catch {
    return {};
  }
}

export function track(event: string, props?: Props): void {
  if (typeof window === 'undefined') return;
  try {
    const merged: Props = { ...readUtm(), ...(props ?? {}) };
    const w = window as unknown as {
      plausible?: (e: string, opts?: { props: Props }) => void;
      __cfBeacon?: { track?: (e: string, p?: Props) => void };
      gtag?: (kind: string, e: string, p?: Props) => void;
    };
    if (typeof w.plausible === 'function') {
      w.plausible(event, Object.keys(merged).length ? { props: merged } : undefined);
      return;
    }
    if (w.__cfBeacon?.track) {
      w.__cfBeacon.track(event, merged);
      return;
    }
    if (typeof w.gtag === 'function') {
      w.gtag('event', event, merged);
    }
  } catch {
    // never throw from analytics
  }
}
